"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Thrown when a user cannot be found
 */
class UserNotFoundError extends client_library_1.ExtendableError {
    constructor() {
        super('The username provided does not exist');
    }
}
exports.default = UserNotFoundError;
